import React from 'react';
import LegalDoc from '../../components/LegalDoc';

export default function SLA() {
  return (
    <LegalDoc
      slug="sla"
      title="Service-Level Agreement (Pilot &amp; Pro plans)"
      subtitle="Public uptime commitment, credit schedule, &amp; status-page transparency."
      version="1.0"
      lastReviewed="2026-02-18"
      controls={["A1.3"]}
    >
      <h2>Coverage</h2>
      <p>This SLA applies to all paid <strong>Pilot</strong> and <strong>Pro</strong> plan customers from the date of first invoice. Free-tier and trial customers receive best-effort availability with no contractual SLA.</p>

      <h2>Uptime commitment</h2>
      <table>
        <thead><tr><th>Plan</th><th>Monthly uptime commitment</th><th>Definition of "available"</th></tr></thead>
        <tbody>
          <tr><td>Pilot</td><td>99.5%</td><td>FastAPI <code>/api/health</code> returns HTTP 200 + JSON <code>{`{"ok": true}`}</code></td></tr>
          <tr><td>Pro</td><td>99.9%</td><td>Same probe + frontend root returns HTTP 200 within 2s</td></tr>
        </tbody>
      </table>
      <p>Uptime is measured by an external monitor (third-party — currently UptimeRobot, will switch to a SOC 2 Type II'd provider before our own Type II audit) pinging every 30 seconds from 3 geographic regions.</p>

      <h2>Service credits</h2>
      <table>
        <thead><tr><th>Monthly uptime</th><th>Pilot credit</th><th>Pro credit</th></tr></thead>
        <tbody>
          <tr><td>99.5% — 100%</td><td>0%</td><td>0%</td></tr>
          <tr><td>99.0% — 99.49%</td><td>10%</td><td>10%</td></tr>
          <tr><td>95.0% — 98.99%</td><td>25%</td><td>25%</td></tr>
          <tr><td>&lt; 95%</td><td>50%</td><td>50%</td></tr>
        </tbody>
      </table>
      <p>Credits are calculated as a percentage of the affected month's invoice. Credits are issued automatically — the customer never has to file a claim. They appear as a line item on the next invoice within 7 business days of month-end.</p>

      <h2>Exclusions</h2>
      <ul>
        <li>Scheduled maintenance announced ≥ 48 hours in advance (we aim for &lt; 1 hour/month, in low-traffic windows)</li>
        <li>Outages caused by a customer-supplied integration (their Airflow webhook, their Stripe account, etc.)</li>
        <li>Force majeure (AWS us-east-1 going dark, CrowdStrike-like third-party kernel panics, etc.) — but we will still file an honest post-mortem</li>
        <li>Trials and free-tier accounts</li>
      </ul>

      <h2>Status page</h2>
      <p>Live status: <a href="https://status.cartie.ai" target="_blank" rel="noreferrer">status.cartie.ai</a> (target launch May 2026). Until launch, status is posted to:</p>
      <ul>
        <li>X/Twitter: <a href="https://x.com/cartie_ai" target="_blank" rel="noreferrer">@cartie_ai</a></li>
        <li>In-app banner on the dashboard</li>
        <li>Email to all affected customers within the comms windows defined in our <a href="/legal/incident-response">Incident Response Playbook</a></li>
      </ul>

      <h2>Honesty clause</h2>
      <blockquote>
        Every other FinOps vendor will publish a 99.9% SLA. We will too. The difference: when we miss it, the credit is automatic, the post-mortem is public, and we'll tell you exactly what we broke and how we'll prevent it. We have a <a href="/roi-pledge">3× ROI Pledge</a>. The SLA is held to the same standard.
      </blockquote>

      <h2>Sign-off</h2>
      <p>SLA approved Feb 18, 2026. Effective May 1, 2026 (post status-page launch). Next review: Aug 1, 2026.</p>
    </LegalDoc>
  );
}
